import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskItsmFeaturesRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-itsm-features',
	path: '/jira/servicedesk/projects/:projectKey/settings/itsm-features',
	exact: true,
};
